module.exports = __webpack_public_path__ + "static/media/socialsharingsite_circle.d7823273.png";